import {
  AnimatedSwitch,
  RouterPanel,
  Section,
  useActiveSectionsTop,
} from 'weblite-router'
import { usePrevious } from '$common/react-hooks/use-previous'
import {
  CallPanel,
  CourseVitrinePanel,
  HomePanel,
  ProfilePanel,
  PvCallManagerPanel,
  RoomPanel,
  RoomProfilePanel,
  SJFSignupPanel,
  VitrinePanel,
  WappPanel,
} from '$scenes/router-panels'

const sectionToIndex: Record<string, number> = {
  left: 0,
  mid: 1,
  right: 2,
  channelVitrine: 3,
  courseVitrine: 4,
  comm: 5,
  sjf: 6,
}

export function AppMobile() {
  const activeSection = useActiveSectionsTop()
  const prevActiveSection = usePrevious(activeSection)

  const sectionToRender =
    activeSection === 'overlay' || activeSection === 'story'
      ? prevActiveSection
      : activeSection

  return (
    <AnimatedSwitch
      name="slideLayers"
      activeKey={sectionToRender ? sectionToIndex[sectionToRender] || 0 : 0}
      keepDisplayMap={{ 1: true }}
    >
      <div>
        <Section
          isInitialSection
          name="left"
          transition={{ name: 'pushSlide', direction: 'inverse' }}
          initialPanel="home"
        >
          <ProfilePanel.Portal data-name="profile">
            <RouterPanel />
          </ProfilePanel.Portal>

          <HomePanel.Portal data-name="home">
            <RouterPanel />
          </HomePanel.Portal>
        </Section>
      </div>

      <div>
        <Section name="mid">
          <RoomPanel.Portal data-name="room">
            <RouterPanel />
          </RoomPanel.Portal>
        </Section>
      </div>

      <div>
        <Section
          name="right"
          transition={{ name: 'slideLayers', direction: 'inverse' }}
        >
          <RoomProfilePanel.Portal data-name="roomProfile">
            <RouterPanel />
          </RoomProfilePanel.Portal>

          <WappPanel.Portal data-name="wapp">
            <RouterPanel />
          </WappPanel.Portal>
        </Section>
      </div>

      <div>
        <Section name="channelVitrine" initialPanel="vitrine">
          <VitrinePanel.Portal data-name="vitrine">
            <RouterPanel />
          </VitrinePanel.Portal>
        </Section>
      </div>

      <div>
        <Section name="courseVitrine" initialPanel="courseVitrine">
          <CourseVitrinePanel.Portal data-name="courseVitrine">
            <RouterPanel />
          </CourseVitrinePanel.Portal>
        </Section>
      </div>

      <div>
        <Section name="comm" initialPanel="call">
          <CallPanel.Portal data-name="call">
            <RouterPanel />
          </CallPanel.Portal>

          <PvCallManagerPanel.Portal data-name="pvCallManager">
            <RouterPanel />
          </PvCallManagerPanel.Portal>
        </Section>
      </div>

      <div>
        <Section name="sjf" initialPanel="sjfSignup">
          <SJFSignupPanel.Portal data-name="sjfSignup">
            <RouterPanel />
          </SJFSignupPanel.Portal>
        </Section>
      </div>
    </AnimatedSwitch>
  )
}
